export default {
  base_url: '/api/illustrator/profile/portfolio/published-book/categories',

  all() {
    return axios.get(this.base_url).then(response => response.data);
  },

};